import { Button } from '@/components/ui/Button/Button';
import { DialogBody, DialogFooter } from '@/components/ui/Dialog/Dialog';
import { Illustration } from '@/components/ui/Illustration/Illustration';
import { useTranslation } from 'react-i18next';
import { useCancelFlow } from '../../context/useCancelFlow';

export const ErrorStep = () => {
  const { t } = useTranslation('scheduling', { keyPrefix: 'cancelDialog.steps.errorStep' });

  const { closeCancelDialog } = useCancelFlow();

  return (
    <>
      <DialogBody className='flex h-full flex-col items-center justify-center text-center'>
        <Illustration name='problem' className='size-28' />
        <div className='max-w-[320px]'>
          <p className='text-heading-m-semibold mb-4'>{t('title')}</p>
          <p>{t('description')}</p>
        </div>
      </DialogBody>
      <DialogFooter>
        <Button className='w-full' onClick={() => closeCancelDialog()}>
          {t('closeButton.label')}
        </Button>
      </DialogFooter>
    </>
  );
};
